export const ensureHttps = (url: string): string => {
  // Trim any whitespace from the URL
  url = url.trim();

  // Check if the URL starts with "http://" or "https://"
  if (!/^https?:\/\//i.test(url)) {
    // Prepend "https://" if neither is present
    url = `https://${url}`;
  }

  return url;
};
